import styled from 'styled-components/macro';

// a simple div to mimic the top navigation, when the page is loading
const Placeholder = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
    background-color: rgba(25, 25, 25, 0.9);
    display: flex;
    align-items: center;
`;

export default Placeholder;
